import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { SelectCustomAlbumPopupProps } from 'reactApp/ui/SelectCustomAlbumPopup/SelectCustomAlbumPopup';

export const openSelectCustomAlbumPopup = (data: SelectCustomAlbumPopupProps) =>
    openPopupHelper<SelectCustomAlbumPopupProps>({
        popupName: popupNames.SELECT_CUSTOM_ALBUM,
        data,
    });

export const closeSelectCustomAlbumPopup = () => closePopupHelper(popupNames.SELECT_CUSTOM_ALBUM);
